import PropTypes from 'prop-types';

/**
 * Card style wrapper with rounded corners
 * @param {{children:JSX.Element}} param0
 * @returns
 */
export default function CardBackground({ children }) {
  return (
    <div className="shadow-sm rounded-2xl bg-white border border-solid border-segments-darker-gray">
      {children}
    </div>
  );
}

CardBackground.propTypes = {
  children: PropTypes.element.isRequired,
};
